export interface User {
    name: string
    role: Roles
}

export enum Roles {
    ADMIN = 'ADMIN',
    MANAGER = 'MANAGER'
}